import { ResponsiveText } from '@farmersdog/corgi-legacy';

export interface DescriptionProps {
  children: string;
}

export function Description({ children }: DescriptionProps) {
  return (
    <ResponsiveText variant="body-1" as="p">
      {children}
    </ResponsiveText>
  );
}
